// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__XTFR9","total":"Cart_total__G7klg","actions":"Cart_actions__VhOa2","button--alt":"Cart_button--alt__-5Bbn","button":"Cart_button__OiLFH"};